import {CommonOptionVM} from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class InspectionRealStartDateOptionsVM extends CommonOptionVM {
  required: true
  not_visible: true

  constructor(data: Partial<InspectionRealStartDateOptionsVM> = {}) {
    super(data)
    this.required = true
    this.not_visible = true
  }

  validateData() {
    const errors: any[] = []
    if (!this.required) {
      errors.push({key: 'required', error_message: 'Required field must be true'})
    }
    if (!this.not_visible) {
      errors.push({key: 'not_visible', error_message: 'Not visible field must be true'})
    }
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default InspectionRealStartDateOptionsVM